
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Busrentalforcorporateinpune() {



    const cardData =
    {
        keyword: 'Bus Rental For Corporate in Pune',
        heading: 'Samarth Travels: Bus Rental For Corporate in Pune',
        headingDescription: 'Samarth Travels provides professional and reliable bus rental for corporate in Pune, perfect for office commutes, conferences, and company outings. Choose from a range of AC and non-AC buses, from 17-seater to 50-seater, all maintained for comfort and punctuality. With trained drivers, transparent pricing, and a focus on corporate convenience, Samarth Travels ensures smooth and stress-free business travel solutions.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

        "topPlaces": [
             {
                "title": "Sinhagad Fort",
                "description": "Perched atop the Sahyadri hills, Sinhagad Fort is a historic hill fortress located about 30 kilometers from Pune. Famous for the Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers breathtaking views, trekking trails, and remnants of ancient military architecture including bastions, gates, and memorials. It's an ideal destination for trekking enthusiasts, history buffs, and nature lovers alike."
            }, 
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada is one of Pune's most iconic landmarks and a symbol of the Maratha Empire. Built in 1732 as the seat of the Peshwas, this grand fortification features majestic gates, elegant fountains, and intricate architecture. Although much of it was destroyed by fire in 1828, its massive stone walls and legendary tales—especially those surrounding the ghost of Narayanrao—still attract thousands of history lovers and tourists each year."
            },
            {
                "title": "Aga Khan Palace",
                "description": "The Aga Khan Palace is a stunning historical monument built in 1892 by Sultan Aga Khan III. It holds immense national significance due to its association with Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters who were imprisoned here during the Quit India Movement. Set in lush green gardens, the palace showcases Italian arches and spacious halls and also houses a museum with photographs, paintings, and personal belongings of Gandhi, making it a must-visit for those interested in India’s independence movement."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "The Pataleshwar Cave Temple is a unique 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single massive basalt rock, this ancient temple is a fine example of monolithic architecture from the Rashtrakuta period. Its main sanctum houses a linga, and the surrounding sanctum sanctorum includes statues of other deities. Despite being in the middle of the bustling city, it offers a tranquil and spiritual atmosphere for visitors."
            }, 
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "This revered Ganesh temple is one of the most visited and richly adorned temples in Maharashtra. Established by a sweet-maker named Dagdusheth Halwai in the late 19th century, the temple is known for its magnificent idol of Lord Ganesh decked in gold and diamonds. The temple draws massive crowds during the Ganesh Chaturthi festival, and its serene ambiance makes it a spiritual haven throughout the year."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This museum is a treasure trove of Indian heritage and folk art, established by Dr. Dinkar Kelkar in memory of his son. It houses over 20,000 rare and artistic artifacts, including musical instruments, sculptures, paintings, utensils, weaponry, and textiles from all over India. The collection gives a vivid picture of everyday life in bygone eras and is especially appealing to art enthusiasts and cultural historians."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Rising 2,100 feet above sea level, Parvati Hill offers panoramic views of Pune city. The hilltop temple complex consists of five main temples, including the Devdeveshwar temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa rule, it is not only a religious site but also a peaceful escape from the city buzz. A climb of 103 stone steps leads to the summit, where history and nature meet."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in the serene Koregaon Park area, the Osho International Meditation Resort is a tranquil oasis for seekers of inner peace and mindfulness. Founded by the spiritual guru Osho, it offers daily meditation sessions, yoga programs, and various wellness therapies in a luxurious, Zen-like environment. Visitors from all over the world come here for spiritual growth, rejuvenation, and to experience the calm ambiance of its lush gardens and modern facilities."
            },
            {
                "title": "Pune Okayama Friendship Garden",
                "description": "Also known as Pu La Deshpande Garden, this beautifully landscaped garden is inspired by Japan’s Okayama Korakuen Garden. Spread over 10 acres, it features artistically arranged lawns, water bodies, bridges, and pathways that create a harmonious blend of nature and design. It's a favorite among photography enthusiasts, families, and couples seeking a peaceful retreat amid nature."
            },
            {
                "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
                "description": "This combined facility includes a zoo, snake park, and a wildlife rescue center. The snake park is known for its wide variety of snakes, including the King Cobra and Indian Python, as well as informative exhibits on reptile behavior and conservation. The adjoining zoo is home to tigers, leopards, elephants, and other animals, making it an engaging educational and recreational spot, especially for children and families."
            }
        ],

"services": [
    {
        "name": "Corporate Bus Hire Services in Pune",
        "description": "Samarth Travels offers professional corporate bus hire services in Pune, perfect for transporting employees, clients, or guests to business events, offsite meetings, and conferences. Our fleet is equipped with AC, spacious seating, and experienced drivers for a comfortable and punctual ride."
    },
    {
        "name": "Rent Bus for Corporate Events Pune",
        "description": "Organizing a corporate event? Rent a well-maintained, air-conditioned bus from Samarth Travels in Pune. Our vehicles are ideal for large group transfers to seminars, trade shows, or executive retreats, ensuring reliable transportation for your entire team."
    },
    {
        "name": "Bus Rental for Corporate Outings in Pune",
        "description": "Make your corporate outings seamless and enjoyable with Samarth Travels’ bus rental services in Pune. Whether it’s a team-building activity, picnic, or resort trip, we provide clean, spacious buses that guarantee group coordination and a pleasant travel experience."
    },
    {
        "name": "Corporate Team Bus Hire in Pune",
        "description": "Move your team in comfort with Samarth Travels’ corporate team bus hire in Pune. Designed for internal events, training programs, and employee transportation, our buses are driven by professionals and come with all essential amenities for business group travel."
    },
    {
        "name": "Affordable Bus Hire for Corporate Events in Pune",
        "description": "Get budget-friendly yet reliable transport for your business events with our affordable corporate bus hire in Pune. Samarth Travels ensures high-quality service, punctual pickups, and group-friendly buses tailored to meet your event logistics requirements."
    },
    {
        "name": "Rent a 32-Seater Bus for Corporate Trips in Pune",
        "description": "Need the right-sized vehicle for a corporate group? Samarth Travels offers 32-seater bus rentals in Pune, ideal for mid-sized teams attending events, retreats, or training sessions. Enjoy spacious interiors, AC comfort, and timely service at a competitive price."
    },
    {
        "name": "Corporate Event Bus Rentals Pune",
        "description": "Ensure smooth logistics for your corporate event with Samarth Travels’ bus rentals in Pune. From venue transfers to hotel pickups, our buses support full-day or multi-day event requirements, providing dependable transport for clients, staff, or executives."
    },
    {
        "name": "Corporate Bus Services for Conferences in Pune",
        "description": "Simplify travel arrangements for your next conference with our specialized corporate bus services in Pune. Samarth Travels provides well-equipped vehicles and professional drivers to manage large-group transport between hotels, conference halls, and offices."
    },
    {
        "name": "Rent a Luxury Bus for Corporate Travel in Pune",
        "description": "For VIP guests or senior executives, Samarth Travels offers luxury bus rentals for corporate travel in Pune. Featuring plush seating, ambient lighting, and climate control, our premium buses ensure a high-comfort travel experience that aligns with your company’s standards."
    },
    {
        "name": "Bus Hire for Corporate Day Trips in Pune",
        "description": "Organizing a one-day corporate tour, workshop, or client visit? Hire a bus from Samarth Travels in Pune for day-long business trips. Our reliable, AC-equipped buses make group transportation stress-free, comfortable, and well-coordinated."
    }
],
"tableData": [
    ["Corporate Bus Hire Services in Pune", "Rent Bus for Corporate Events Pune"],
    ["Bus Rental for Corporate Outings in Pune", "Corporate Team Bus Hire in Pune"],
    ["Affordable Bus Hire for Corporate Events in Pune", "Rent a 32-Seater Bus for Corporate Trips in Pune"],
    ["Corporate Event Bus Rentals Pune", "Corporate Bus Services for Conferences in Pune"],
    ["Rent a Luxury Bus for Corporate Travel in Pune", "Bus Hire for Corporate Day Trips in Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Bus Rental for Corporate Events in Pune",
        "WhyChoosedescription": "Samarth Travels provides dependable and efficient bus rental services for corporate events in Pune. Whether it’s for conferences, seminars, client meetings, corporate outings, or team-building activities, we offer a variety of buses to meet the needs of your company. Our buses are ideal for transporting employees and clients comfortably, ensuring they arrive on time and in style."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Buses for Corporate Groups",
        "WhyChoosedescription": "Our fleet includes a wide range of buses, from minibuses to large luxury coaches, catering to various group sizes. All buses are fully air-conditioned with comfortable seating, ample legroom, and modern amenities such as Wi-Fi (on select buses), ensuring that your employees can relax or prepare for the event during the journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Professional Corporate Travel",
        "WhyChoosedescription": "Our drivers are highly trained professionals, ensuring a safe and smooth journey for your corporate group. They are familiar with Pune's routes and traffic patterns, which helps in avoiding delays and reaching your destination on time. Our drivers also prioritize professionalism, courtesy, and customer satisfaction throughout the journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Corporate Bus Rentals",
        "WhyChoosedescription": "At Samarth Travels, we offer competitive and transparent pricing for corporate bus rentals in Pune. We understand the importance of staying within budget, so we provide clear, upfront pricing with no hidden charges. Our goal is to offer great value for your corporate transportation needs without compromising on quality or comfort."
    },
    {
        "WhyChooseheading": "Available 24/7 for Flexible Scheduling of Corporate Events",
        "WhyChoosedescription": "Samarth Travels is available around the clock to accommodate your corporate event schedule. Whether you need early morning transportation for a conference, or late-night transfers after a corporate dinner, we offer flexible 24/7 availability. You can trust us to provide transportation at any time, ensuring your corporate events run smoothly."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Real-Time Updates",
        "WhyChoosedescription": "Booking your corporate bus rental is quick and easy with Samarth Travels. You can book through our website or by contacting our customer service team. Once your booking is confirmed, you’ll receive real-time updates including live tracking, driver details, and estimated arrival times, so you're always informed and confident that your transportation is on track."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses for Corporate Groups",
        "WhyChoosedescription": "We prioritize cleanliness and safety for all corporate group travel. Each bus in our fleet is thoroughly cleaned and sanitized before every trip to provide a safe and hygienic environment for your employees and clients. Additionally, our buses are regularly maintained and inspected to ensure smooth operation and comfort during your journey."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenient Transactions",
        "WhyChoosedescription": "Samarth Travels offers a variety of secure payment methods for your corporate bookings, including cash, UPI, credit/debit cards, and digital wallets. You can choose the payment option that works best for your organization, ensuring a seamless and hassle-free payment process."
    }
]














    }

const faqData = [
    {
        id: 1,
        question: 'How can I book a corporate bus rental in Pune with Samarth Travels?',
        answer: 'Booking a corporate bus rental in Pune with Samarth Travels is quick and hassle-free. Just contact our team via website or phone, share your travel details like number of passengers, pickup location, destination, and schedule—we’ll take care of the rest.',
    },
    {
        id: 2,
        question: 'What types of buses are available for corporate transport?',
        answer: 'We offer a variety of buses ideal for corporate needs, including 22-seater, 32-seater, 40-seater, and 50-seater AC and non-AC buses. These are perfect for office commutes, off-site events, seminars, and conferences.',
    },
    {
        id: 3,
        question: 'Are your corporate buses suitable for daily employee transportation?',
        answer: 'Yes, our buses are frequently used for daily employee commutes. We offer monthly rental packages with punctual and professional service to ensure smooth daily operations for your company.',
    },
    {
        id: 4,
        question: 'Is it possible to rent multiple buses for a corporate event in Pune?',
        answer: 'Absolutely. Samarth Travels can arrange multiple buses for large corporate events. We handle transport logistics efficiently for team outings, product launches, or group training sessions.',
    },
    {
        id: 5,
        question: 'Do your corporate buses come with amenities?',
        answer: 'Yes, our corporate buses are equipped with pushback seats, air-conditioning, clean interiors, and enough space for comfortable travel. We focus on providing a pleasant experience for every passenger.',
    },
    {
        id: 6,
        question: 'Can I get a customized route or multiple pickup points?',
        answer: 'Yes, we offer complete flexibility with routes and pickup/drop locations based on your company’s needs. Our team works closely with you to ensure seamless transportation management.',
    },
    {
        id: 7,
        question: 'Is there 24/7 support for corporate bus rentals in Pune?',
        answer: 'Yes, we provide round-the-clock assistance for corporate rentals. Whether it’s early morning employee drop-offs or late-night return trips, our operations team is always available to support you.',
    },
];

const testimonials = [
    {
        name: 'Mr. Arvind Kulkarni',
        role: 'Operations Manager, Digitech Solutions',
        text: 'Samarth Travels provided excellent bus rental service for our corporate event. The buses arrived on time, were very clean, and the drivers were well-mannered. A very professional experience overall.',
        image: '/img/testimonial/testi_2_32.jpg',
    },
    {
        name: 'Ms. Sneha Rane',
        role: 'HR Executive, Nimbus Corp.',
        text: 'We hired two buses for our employee training program in Pune. Samarth Travels handled everything smoothly—from coordination to pickup and drop. Reliable and stress-free service!',
        image: '/img/testimonial/testi_2_33.jpg',
    },
];






















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental for Corporate in Pune",
  "image": "https://samarthtravels.com/assets/images/bus-rental-for-corporate-pune.jpg",
  "description": "Samarth Travels offers reliable and affordable corporate bus rental services in Pune. Book buses for events, team outings, conferences, and corporate day trips. Choose from 32-seater and luxury bus options to suit your company’s travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6682"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/bus-rental-for-corporate-in-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Bus Rental for Corporate in Pune | Events, Team Outings & Conferences | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a bus for corporate travel in Pune with Samarth Travels. We offer affordable and luxury corporate bus rentals for events, outings, and conferences. Choose from 32-seater or AC buses tailored for corporate needs." 
  />
  <meta 
    name="keywords" 
    content="Corporate Bus Hire Services in Pune, Rent Bus for Corporate Events Pune, Bus Rental for Corporate Outings in Pune, Corporate Team Bus Hire in Pune, Affordable Bus Hire for Corporate Events in Pune, Rent a 32-Seater Bus for Corporate Trips in Pune, Corporate Event Bus Rentals Pune, Corporate Bus Services for Conferences in Pune, Rent a Luxury Bus for Corporate Travel in Pune, Bus Hire for Corporate Day Trips in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busrentalforcorporateinpune;